
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const UserTableHeader = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Email</TableHead>
        <TableHead>Mobile Number</TableHead>
        <TableHead>Role</TableHead>
        <TableHead>School ID</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};
